export * from '@primeuix/themes/aura/checkbox';
export { default } from '@primeuix/themes/aura/checkbox';
